import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import PrivateRoute from './PrivateRoute'
import LayoutRoutes from './LayoutRoutes'
import { authRoutes } from './AuthRoutes';
import Login from '../Component/Authentication/Login';

const RouterData = () => {
  const publicUrl = process.env.PUBLIC_URL || '';
  
  return (
    <BrowserRouter basename={publicUrl}>
      <Routes>
        {/* Rutas de autenticación (públicas) */}
        <Route path="/login" element={<Login />} />
        {authRoutes.map(({ path, Component }, i) => {
          // Remover PUBLIC_URL del path si está presente
          const cleanPath = path.startsWith(publicUrl) ? path.substring(publicUrl.length) : path;
          return <Route path={cleanPath} element={Component} key={i} />;
        })}
        
        {/* Rutas protegidas - requieren autenticación */}
        <Route path="/*" element={<PrivateRoute />}> 
          <Route path="*" element={<LayoutRoutes />} />
        </Route>
        
        {/* Ruta raíz - redirige al dashboard */}
        <Route 
          path="/" 
          element={<Navigate to="/dashboard/default" replace />} 
        />
      </Routes>
    </BrowserRouter>
  )
}

export default RouterData
